<template>
  <svg
    :width="128"
    :height="82"
    viewBox="0 0 64 41"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- === GRADIENTE === -->
    <defs>
      <linearGradient id="grad" x1="64.7804" y1="4.55607" x2="29.243" y2="4.73832" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stop-color="#F4711B" />
        <stop offset="100%" stop-color="#D5130F" />
      </linearGradient>
    </defs>

    <!-- === FILL PATH (gradiente animado de posição) === -->
    <path
      d="M39.1055 0H63.8691C63.5861 8.62617 56.6169 12.0407 53.0793 12.9392C52.3718 25.1597 42.1125 25.8785 40.5206 25.8785C38.9287 25.8785 27.785 24.9799 27.785 13.119C27.785 3.48641 35.332 0.479231 39.1055 0Z"
      fill="url(#grad)"
      :transform="`translate(${deltaX * (1-t)}, ${deltaY * (1-t)})`"
    />

    <!-- === GRAY PATH self-drawing === -->
    <path
      d="M17.5794 18.9534L3 35.1711C9.5052 41.0267 16.9791 38.2541 20.1631 36.2596C13.6282 30.2766 15.7178 22.2292 17.5794 18.9534Z"
      fill="none"
      stroke="#C8BFBC"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      :stroke-dasharray="500"
      :stroke-dashoffset="500 - (500 * t)"
    />

    <!-- === WHITE PATH self-drawing === -->
    <path
      d="M27.4206 12.7571H52.9346C52.643 21.5047 45.4626 24.9674 41.8178 25.8786C41.0888 38.2711 30.5187 39.0001 28.8785 39.0001C27.2383 39.0001 15.757 38.0889 15.757 26.0608C15.757 16.2926 23.5327 13.2431 27.4206 12.7571Z"
      fill="none"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      :stroke-dasharray="500"
      :stroke-dashoffset="500 - (500 * t)"
    />
  </svg>
</template>

<script>
export default {
  name: "SelfDrawingIcon",
  data() {
    return {
      t: 0,           
      duration: 2000, 
      repeat: true,
      deltaX: 17.42 - 39.1, 
      deltaY: 12.75 - 0,    
      raf: null
    };
  },
  mounted() {
    let start = null;
    const animate = (time) => {
      if (!start) start = time;
      const progress = (time - start) / this.duration;
      this.t = progress % 1; // looping

      if (this.repeat || progress < 1) {
        this.raf = requestAnimationFrame(animate);
      }
    };
    this.raf = requestAnimationFrame(animate);
  },
  beforeDestroy() {
    if (this.raf) cancelAnimationFrame(this.raf);
  }
};
</script>